/* eslint-disable jsx-a11y/anchor-is-valid */
import { Key, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import SelectCountryCode from "../components/modals/select-country-code";
import { SelectTerritory } from "../components/modals/select-territory";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import StoreFooter from "../components/store/store-footer";
import { useTranslation } from "react-i18next";

export default function Articles() {
    const { id } = useParams();
    const [article, setArticle] = useState<any>(null);
    const [recentArticles, setRecentArticles] = useState<any[]>([]);

    const { t, i18n } = useTranslation();

    const handleChangeLang = (lang: string) => {
        i18n.changeLanguage(lang);
        if (lang === "ar" || lang === "ur") {
            document.documentElement.dir = "rtl";
        } else {
            document.documentElement.dir = "ltr";
        }
    };

    useEffect(() => {
        axios.get("/articles").then((res) => {
            const articles = res.data?.data?.articles || [];
            setRecentArticles(articles);
            if (!id && articles.length > 0) {
                setArticle(articles[0]);
            }
        });
    }, []);

    useEffect(() => {
        if (id) {
            axios.get(`/articles/${id}`).then((res) => {
                setArticle(res.data?.data || null);
            });
        }
    }, [id]);

    const getTitle = (a: any) => {
        if (!a) return "Untitled";
        if (i18n.language === "ar") return a.title_ar || a.title;
        if (i18n.language === "ur") return a.title_ur || a.title;
        return a.title_en || a.title;
    };

    const getContent = (a: any) => {
        if (!a) return "<p>No content available</p>";
        if (i18n.language === "ar") return a.content_ar || a.content;
        if (i18n.language === "ur") return a.content_ur || a.content;
        return a.content_en || a.content;
    };

    return (
        <>
            {" "}
            <div className="py-8 font-sans antialiased">
                <h2 className="w-full text-center text-2xl font-medium sm:text-3xl md:text-[36px]">
                    {t("articles")}
                </h2>

                {article ? (
                    <div className="container mx-auto px-4 py-8 sm:px-6 md:px-8 md:py-[3rem] lg:px-[10rem]">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
                            <aside className="order-1 lg:order-2 lg:col-span-1">
                                <div className="rounded-xl border border-[#e3e3e3] bg-white p-4 sm:p-5">
                                    <div className="pb-3">
                                        <h3 className="mb-3 text-base font-bold text-[#313131] sm:text-lg">
                                            {t("recent-articles")}
                                        </h3>
                                        <div className="w-1/3 border-b-[4px] border-[#006536] sm:w-1/2 md:w-3/5"></div>
                                    </div>

                                    {recentArticles.length > 0 ? (
                                        <div className="space-y-3 sm:space-y-4">
                                            {recentArticles.map((a) => (
                                                <div
                                                    key={a.id}
                                                    onClick={() =>
                                                        setArticle(a)
                                                    }
                                                    className={`flex cursor-pointer items-center gap-3 rounded-lg border-b p-2 transition last:border-b-0 sm:p-3 ${
                                                        article?.id === a.id
                                                            ? "bg-none"
                                                            : "hover:bg-gray-100"
                                                    }`}
                                                >
                                                    {a.image && (
                                                        <img
                                                            src={a.image?.replace(
                                                                "https://testing.zabehaty.uae.zabe7ti.website/uploads",
                                                                "",
                                                            )}
                                                            alt={getTitle(a)}
                                                            className="h-12 w-12 flex-shrink-0 rounded object-cover sm:h-14 sm:w-14"
                                                        />
                                                    )}
                                                    <div className="flex flex-col">
                                                        <p
                                                            className={`line-clamp-2 text-[13px] font-semibold sm:text-[14px] ${
                                                                article?.id ===
                                                                a.id
                                                                    ? "text-[#006536]"
                                                                    : "text-gray-900"
                                                            }`}
                                                        >
                                                            {getTitle(a)}
                                                        </p>
                                                        <div className="flex items-center pt-1 text-[12px] text-[#535353] sm:text-[14px]">
                                                            <svg
                                                                className="mr-1"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M17.6752 5.42875C17.5765 3.78656 16.2052 2.5 14.5536 2.5H13.7496V1.875C13.7496 1.53 13.4696 1.25 13.1246 1.25C12.7796 1.25 12.4996 1.53 12.4996 1.875V2.5H7.49958V1.875C7.49958 1.53 7.21958 1.25 6.87458 1.25C6.52958 1.25 6.24958 1.53 6.24958 1.875V2.5H5.44552C3.79364 2.5 2.42239 3.78656 2.32395 5.42875C2.13864 8.5175 2.14208 11.6506 2.33427 14.7409C2.43177 16.3103 3.68895 17.5675 5.25833 17.665C6.83114 17.7628 8.4152 17.8116 9.99927 17.8116C11.583 17.8116 13.1674 17.7628 14.7402 17.665C16.3096 17.5675 17.5668 16.3103 17.6643 14.7409C17.8568 11.6522 17.8602 8.51937 17.6752 5.42875ZM16.4171 14.6634C16.3583 15.605 15.6043 16.3591 14.663 16.4175C11.5686 16.6097 8.43052 16.6097 5.33614 16.4175C4.39458 16.3587 3.64052 15.6047 3.58208 14.6634C3.43427 12.2875 3.40395 9.88656 3.48302 7.5H16.5165C16.5952 9.8875 16.5649 12.2884 16.4171 14.6634ZM6.87458 5C7.21958 5 7.49958 4.72 7.49958 4.375V3.75H12.4996V4.375C12.4996 4.72 12.7796 5 13.1246 5C13.4696 5 13.7496 4.72 13.7496 4.375V3.75H14.5536C15.5452 3.75 16.3683 4.52031 16.4274 5.50344C16.4421 5.75156 16.4483 6.00125 16.4605 6.25H3.53864C3.55114 6.00125 3.55708 5.75156 3.57177 5.50344C3.63083 4.52031 4.45364 3.75 5.44552 3.75H6.24958V4.375C6.24958 4.72 6.52958 5 6.87458 5Z"
                                                                    fill="#006536"
                                                                />
                                                                <path
                                                                    d="M6.875 11.25C7.39277 11.25 7.8125 10.8303 7.8125 10.3125C7.8125 9.79473 7.39277 9.375 6.875 9.375C6.35723 9.375 5.9375 9.79473 5.9375 10.3125C5.9375 10.8303 6.35723 11.25 6.875 11.25Z"
                                                                    fill="#006536"
                                                                />
                                                                <path
                                                                    d="M10 11.25C10.5178 11.25 10.9375 10.8303 10.9375 10.3125C10.9375 9.79473 10.5178 9.375 10 9.375C9.48223 9.375 9.0625 9.79473 9.0625 10.3125C9.0625 10.8303 9.48223 11.25 10 11.25Z"
                                                                    fill="#006536"
                                                                />
                                                                <path
                                                                    d="M6.875 14.375C7.39277 14.375 7.8125 13.9553 7.8125 13.4375C7.8125 12.9197 7.39277 12.5 6.875 12.5C6.35723 12.5 5.9375 12.9197 5.9375 13.4375C5.9375 13.9553 6.35723 14.375 6.875 14.375Z"
                                                                    fill="#006536"
                                                                />
                                                                <path
                                                                    d="M13.125 11.25C13.6428 11.25 14.0625 10.8303 14.0625 10.3125C14.0625 9.79473 13.6428 9.375 13.125 9.375C12.6072 9.375 12.1875 9.79473 12.1875 10.3125C12.1875 10.8303 12.6072 11.25 13.125 11.25Z"
                                                                    fill="#006536"
                                                                />
                                                                <path
                                                                    d="M13.125 14.375C13.6428 14.375 14.0625 13.9553 14.0625 13.4375C14.0625 12.9197 13.6428 12.5 13.125 12.5C12.6072 12.5 12.1875 12.9197 12.1875 13.4375C12.1875 13.9553 12.6072 14.375 13.125 14.375Z"
                                                                    fill="#006536"
                                                                />
                                                                <path
                                                                    d="M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z"
                                                                    fill="#006536"
                                                                />
                                                            </svg>{" "}
                                                            {a.created_at
                                                                ? new Date(
                                                                      a.created_at,
                                                                  ).toLocaleDateString(
                                                                      "en-GB",
                                                                      {
                                                                          day: "numeric",
                                                                          month: "long",
                                                                          year: "numeric",
                                                                      },
                                                                  )
                                                                : "Unknown date"}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-sm text-gray-500">
                                            {t("no-recent-articles")}
                                        </p>
                                    )}
                                </div>
                            </aside>
                            <div className="order-2 lg:order-1 lg:col-span-2">
                                <h1 className="mb-3 text-2xl font-bold sm:text-3xl md:text-[36px]">
                                    {getTitle(article)}
                                </h1>
                                <p className="mb-4 flex items-center text-sm font-semibold text-[#535353] sm:text-[14px]">
                                    <svg
                                        className="mr-1"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17.6752 5.42875C17.5765 3.78656 16.2052 2.5 14.5536 2.5H13.7496V1.875C13.7496 1.53 13.4696 1.25 13.1246 1.25C12.7796 1.25 12.4996 1.53 12.4996 1.875V2.5H7.49958V1.875C7.49958 1.53 7.21958 1.25 6.87458 1.25C6.52958 1.25 6.24958 1.53 6.24958 1.875V2.5H5.44552C3.79364 2.5 2.42239 3.78656 2.32395 5.42875C2.13864 8.5175 2.14208 11.6506 2.33427 14.7409C2.43177 16.3103 3.68895 17.5675 5.25833 17.665C6.83114 17.7628 8.4152 17.8116 9.99927 17.8116C11.583 17.8116 13.1674 17.7628 14.7402 17.665C16.3096 17.5675 17.5668 16.3103 17.6643 14.7409C17.8568 11.6522 17.8602 8.51937 17.6752 5.42875ZM16.4171 14.6634C16.3583 15.605 15.6043 16.3591 14.663 16.4175C11.5686 16.6097 8.43052 16.6097 5.33614 16.4175C4.39458 16.3587 3.64052 15.6047 3.58208 14.6634C3.43427 12.2875 3.40395 9.88656 3.48302 7.5H16.5165C16.5952 9.8875 16.5649 12.2884 16.4171 14.6634ZM6.87458 5C7.21958 5 7.49958 4.72 7.49958 4.375V3.75H12.4996V4.375C12.4996 4.72 12.7796 5 13.1246 5C13.4696 5 13.7496 4.72 13.7496 4.375V3.75H14.5536C15.5452 3.75 16.3683 4.52031 16.4274 5.50344C16.4421 5.75156 16.4483 6.00125 16.4605 6.25H3.53864C3.55114 6.00125 3.55708 5.75156 3.57177 5.50344C3.63083 4.52031 4.45364 3.75 5.44552 3.75H6.24958V4.375C6.24958 4.72 6.52958 5 6.87458 5Z"
                                            fill="#01E784"
                                        />
                                        <path
                                            d="M6.875 11.25C7.39277 11.25 7.8125 10.8303 7.8125 10.3125C7.8125 9.79473 7.39277 9.375 6.875 9.375C6.35723 9.375 5.9375 9.79473 5.9375 10.3125C5.9375 10.8303 6.35723 11.25 6.875 11.25Z"
                                            fill="#01E784"
                                        />
                                        <path
                                            d="M10 11.25C10.5178 11.25 10.9375 10.8303 10.9375 10.3125C10.9375 9.79473 10.5178 9.375 10 9.375C9.48223 9.375 9.0625 9.79473 9.0625 10.3125C9.0625 10.8303 9.48223 11.25 10 11.25Z"
                                            fill="#01E784"
                                        />
                                        <path
                                            d="M6.875 14.375C7.39277 14.375 7.8125 13.9553 7.8125 13.4375C7.8125 12.9197 7.39277 12.5 6.875 12.5C6.35723 12.5 5.9375 12.9197 5.9375 13.4375C5.9375 13.9553 6.35723 14.375 6.875 14.375Z"
                                            fill="#01E784"
                                        />
                                        <path
                                            d="M13.125 11.25C13.6428 11.25 14.0625 10.8303 14.0625 10.3125C14.0625 9.79473 13.6428 9.375 13.125 9.375C12.6072 9.375 12.1875 9.79473 12.1875 10.3125C12.1875 10.8303 12.6072 11.25 13.125 11.25Z"
                                            fill="#01E784"
                                        />
                                        <path
                                            d="M13.125 14.375C13.6428 14.375 14.0625 13.9553 14.0625 13.4375C14.0625 12.9197 13.6428 12.5 13.125 12.5C12.6072 12.5 12.1875 12.9197 12.1875 13.4375C12.1875 13.9553 12.6072 14.375 13.125 14.375Z"
                                            fill="#01E784"
                                        />
                                        <path
                                            d="M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z"
                                            fill="#01E784"
                                        />
                                    </svg>{" "}
                                    {article.created_at
                                        ? new Date(
                                              article.created_at,
                                          ).toLocaleDateString("en-GB", {
                                              day: "numeric",
                                              month: "long",
                                              year: "numeric",
                                          })
                                        : "Unknown date"}
                                </p>

                                {article.image && (
                                    <img
                                        src={article.image?.replace(
                                            "https://testing.zabehaty.uae.zabe7ti.website/uploads",
                                            "",
                                        )}
                                        alt={getTitle(article)}
                                        className="mb-4 max-h-[250px] w-full rounded-lg object-cover sm:max-h-[400px]"
                                    />
                                )}

                                {/* Article Content */}
                                <div
                                    className="prose prose-sm sm:prose-base md:prose-lg max-w-none leading-relaxed text-gray-700"
                                    dangerouslySetInnerHTML={{
                                        __html: getContent(article),
                                    }}
                                />

                                {article.paragraphs?.length > 0 && (
                                    <div className="mt-6 space-y-4">
                                        {article.paragraphs.map(
                                            (p: any, i: any) => (
                                                <div
                                                    key={i}
                                                    className="prose prose-sm sm:prose-base md:prose-lg max-w-none leading-relaxed text-gray-700"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            p.text_en ||
                                                            p.text ||
                                                            "",
                                                    }}
                                                />
                                            ),
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <p className="h-[400px] py-10 text-center">
                        {t("loading")}
                    </p>
                )}
            </div>
        </>
    );
}
